"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvokablePath = void 0;
var isArray_1 = __importDefault(require("lodash/isArray"));
var path_1 = require("../path");
var resolveValue_1 = require("./resolveValue");
var wildcard_1 = require("../wildcard");
var getInvokablePath = function (structure, op, params) {
    var path = op.path.reduce(function (acc, x) {
        var value = (0, resolveValue_1.resolveValue)(structure, x, params);
        if (value && value.__symbol__ === path_1.PathSymbol) {
            var expanded = value.__expand__();
            if ((0, isArray_1.default)(expanded)) {
                acc = acc.concat(expanded);
            }
        }
        else {
            if (value === wildcard_1.wildcard) {
                acc.push("*");
            }
            else {
                acc.push(value);
            }
        }
        return acc;
    }, []);
    if (path.includes(undefined) || path.includes(null)) {
        return;
    }
    else {
        return "/" + path.join("/");
    }
};
exports.getInvokablePath = getInvokablePath;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0SW52b2thYmxlUGF0aC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9ncmFwaC9nZXRJbnZva2FibGVQYXRoLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQU1BLDJEQUFxQztBQUNyQyxnQ0FBcUM7QUFDckMsK0NBQThDO0FBQzlDLHdDQUF1QztBQUVoQyxJQUFNLGdCQUFnQixHQUFHLFVBQzlCLFNBQXlCLEVBQ3pCLEVBQWtDLEVBQ2xDLE1BQXVCO0lBRXZCLElBQU0sSUFBSSxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsTUFBTSxDQUFDLFVBQUMsR0FBRyxFQUFFLENBQU07UUFDdEMsSUFBTSxLQUFLLEdBQUcsSUFBQSwyQkFBWSxFQUFDLFNBQVMsRUFBRSxDQUFDLEVBQUUsTUFBTSxDQUFDLENBQUM7UUFDakQsSUFBSSxLQUFLLElBQUksS0FBSyxDQUFDLFVBQVUsS0FBSyxpQkFBVSxFQUFFO1lBQzVDLElBQU0sUUFBUSxHQUFHLEtBQUssQ0FBQyxVQUFVLEVBQUUsQ0FBQztZQUNwQyxJQUFJLElBQUEsaUJBQU8sRUFBQyxRQUFRLENBQUMsRUFBRTtnQkFDckIsR0FBRyxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQUMsUUFBUSxDQUFDLENBQUM7YUFDNUI7U0FDRjthQUFNO1lBQ0wsSUFBSSxLQUFLLEtBQUssbUJBQVEsRUFBRTtnQkFDdEIsR0FBRyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQzthQUNmO2lCQUFNO2dCQUNMLEdBQUcsQ0FBQyxJQUFJLENBQUMsS0FBSyxDQUFDLENBQUM7YUFDakI7U0FDRjtRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQVcsQ0FBQyxDQUFDO0lBQ2hCLElBQUksSUFBSSxDQUFDLFFBQVEsQ0FBQyxTQUFTLENBQUMsSUFBSSxJQUFJLENBQUMsUUFBUSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQ25ELE9BQU87S0FDUjtTQUFNO1FBQ0wsT0FBTyxHQUFHLEdBQUcsSUFBSSxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsQ0FBQztLQUM3QjtBQUNILENBQUMsQ0FBQztBQTFCVyxRQUFBLGdCQUFnQixvQkEwQjNCIn0=